<template>
  <div id="after-login">
    <div class="flex flex-wrap items-center flex-grow w-full justify-center" style="height: 80vh;">
      <div class="lg:w-1/4 md:w-1/3 sm:w-1/2 w-full" v-if="config.gocheckin_feature == 1 || config.reminder_package_active == 1">
        <div class="after-login-box flex flex-col align-center" @click="selectItem('checkout')">
          <vx-card class="after-login-card shadow-lg">
            <feather-icon icon="CheckSquareIcon" svgClasses="stroke-current" />
          </vx-card>
          <p class="text-3xl mt-6">Go Checkout</p>
        </div>
      </div>

      <!-- <div class="lg:w-1/4 md:w-1/3 sm:w-1/2 w-full" v-if="config.appointment_feature == 1"> -->
      <div class="lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
        <div class="after-login-box flex flex-col align-center" @click="selectItem('appointment')">
          <vx-card class="after-login-card shadow-lg">
            <feather-icon icon="CalendarIcon" svgClasses="stroke-current" />
          </vx-card>
          <p class="text-3xl mt-6">Go Booking</p>
        </div>
      </div>

      <div class="lg:w-1/4 md:w-1/3 sm:w-1/2 w-full" v-if="config.order_feature == 1">
        <div class="after-login-box flex flex-col align-center" @click="selectItem('order')">
          <vx-card class="after-login-card shadow-lg">
            <feather-icon
              icon="ShoppingCartIcon"
              svgClasses="stroke-current"
              style="transform: translate(-7px, 7px);"
            />
          </vx-card>
          <p class="text-3xl mt-6">Order Online</p>
        </div>
      </div>

      <div class="lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
        <div class="after-login-box flex flex-col align-center" @click="selectItem('setting')">
          <vx-card class="after-login-card shadow-lg">
            <feather-icon icon="UserIcon" svgClasses="stroke-current" />
          </vx-card>
          <p class="text-3xl mt-6">Go Check In</p>
        </div>
      </div>

      <!-- <div class="lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
        <div class="after-login-box flex flex-col align-center" @click="selectItem('article')">
          <vx-card class="after-login-card shadow-lg">
            <feather-icon
              icon="LayersIcon"
              svgClasses="stroke-current"
            />
          </vx-card>
          <p class="text-3xl mt-6">CMS</p>
        </div>
      </div> -->

      <div class="lg:w-1/4 md:w-1/3 sm:w-1/2 w-full" v-if="config.pos_feature == 1">
        <div class="after-login-box flex flex-col align-center" @click="selectItem('gopos')">
          <vx-card class="after-login-card shadow-lg">
            <feather-icon icon="DollarSignIcon" svgClasses="stroke-current" />
          </vx-card>
          <p class="text-3xl mt-6">GoPOS</p>
        </div>
      </div>

      <vs-prompt
        title="Change password"
        @accept="acceptAlert"
        :active.sync="popupChangePassword"
        type="confirm"
        class="first-sign-prompt"
        :class="{'hide-cancel': config.pos_feature == 1}"
      >
        <div class="con-exemple-prompt">
          <div class="mb-6">
            <span style="color:red">** User must change password for first time sign in!</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Old Password</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input type="password" id="oldPass" class="w-full" icon-pack="feather" icon="icon-lock" icon-no-border v-model="old_password" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>New Password</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input type="password" id="newPass" class="w-full" icon-pack="feather" icon="icon-lock" icon-no-border v-model="new_password" 
                name="new_password"
                v-validate="{regex: '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$'}" 
                :danger="errors.has('new_password')"
                danger-text="New password shall has at least 8 characters, 1 lowercase character, 1 UPPERCASE character and 1 special character!"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Confirm Password</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input type="password" id="confirmPass" class="w-full" icon-pack="feather" icon="icon-lock" icon-no-border v-model="confirm_password" />
            </div>
          </div>
        </div>
      </vs-prompt>
    </div>
  </div>
</template>


<script>
/* eslint-disable */
export default {
  data(){
    return {
      popupChangePassword: false,
      old_password: '',
      new_password: '',
      confirm_password: '',
      showOld: false,
      showNew: false,
      showConfirm : false,
      resetData: true
    }
  },
  created() {
    this.$store.dispatch("auth/GET_USER_SIGNIN_INFO").then(() => {
      let data = this.$store.getters["auth/userSigninInfo"];
      if(data.first_sign_in == 1){
        this.popupChangePassword = true;
      }
      if(this.userInfo && this.userInfo.trialExpireDate && this.userInfo.trialExpireDate != undefined) {
        this.popupChangePassword = false;
      }
    })

    this.$emit("InAfterLogin");
    this.messaging = window.firebaseMessaging;
    if (typeof firebaseMessaging !== 'undefined' && firebaseMessaging !== undefined && Notification && firebaseMessaging.publicVapidKeyToUse == null){
      firebaseMessaging.usePublicVapidKey(
        "BFmDEp45EDOQGI7TUk905Y2BjK-76hRT9QOnl-2O227onTLvIL9iqHcxgBzD0ae24MvVr9p0-04d8Krlgx69PNQ"
      );
    Notification.requestPermission().then(permission => {
      if (permission === "granted") {
        // console.log("Notification permission granted.");
        firebaseMessaging
          .getToken()
          .then(currentToken => {
            if (currentToken) {
              const obj = {
                token: currentToken,
                user_agent: JSON.stringify(navigator.userAgent)
              };
              // console.log(obj)
              localStorage.setItem('fcmToken', currentToken);
              this.$store.dispatch("auth/REGISTER_TOKEN", obj);
            } else {
              console.log(
                "No Instance ID token available. Request permission to generate one."
              );
            }
          })
          .catch(err => {
            console.log("An error occurred while retrieving token. ", err);
          });
      } else {
        console.log("Unable to get permission to notify.");
      }
    });
    firebaseMessaging.onTokenRefresh(() => {
      firebaseMessaging
        .getToken()
        .then(refreshedToken => {
          if (refreshedToken) {
            const obj = {
              token: refreshedToken,
              user_agent: JSON.stringify(navigator.userAgent)
            };
            localStorage.setItem('fcmToken', currentToken);
            this.$store.dispatch("auth/REGISTER_TOKEN", obj);
          } else {
            console.log(
              "No Instance ID token available. Request permission to generate one."
            );
          }
        })
        .catch(err => {
          console.log("Unable to retrieve refreshed token ", err);
        });
    });
    }
  },
  // destroyed() {
  //   this.$emit('OutAfterLogin');
  // },
  watch:{
    popupChangePassword: {
      immediate: true,
      deep: true,
      handler() {
        if(this.resetData) {
          this.old_password = '';
          this.new_password = '';
          this.confirm_password = '';
        }
      }
    },
    userInfo: {
      immediate: true,
      deep: true,
      handler() {
        if(this.userInfo && this.userInfo.trialExpireDate && this.userInfo.trialExpireDate != undefined) {
          this.popupChangePassword = false;
        }
      }
    }
  },
  methods: {
    openLoadingInDiv(){
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
      this.isOpenLoading = true;
      setTimeout( ()=> {
        if(this.isOpenLoading) {
          this.closeLoading();
          this.$vs.dialog({
            color: 'danger',
            title: 'Notification',
            text: 'Change password failed',
            acceptText: 'OK'
          })
        }
      }, 10000);
    },
    closeLoading() {
      this.$vs.loading.close('#app > .con-vs-loading');
      this.isOpenLoading = false;
    },
    acceptAlert(){
      this.resetData = true;
      if(!this.errors.has('new_password') && this.old_password != "" && this.new_password != "" && this.confirm_password != "" && this.new_password == this.confirm_password) {
        if(!this.isOpenLoading) {
          this.openLoadingInDiv();
        }
        const obj = {
          old_password: this.old_password,
          new_password: this.new_password,
          repeat_password: this.confirm_password
        }
        this.$store.dispatch("appSetting/CHANGE_PASSWORD" ,obj).then(() => {
          this.old_password = '';
          this.new_password = '';
          this.confirm_password = '';
          this.closeLoading();
          this.$vs.notify({
            title:'Success',
            text:'Change password success!',
            color:'success',
            position:'top-right'
          })
        }).catch((err) => {
          this.closeLoading();
          if(err.old_password){
            this.$vs.notify({
              title:'Fail',
              text: err.old_password[0],
              color:'danger',
              position:'top-right'
            })
            this.popupChangePassword = true;
          }else if(err.new_password){
            this.$vs.notify({
              title:'Fail',
              text: err.new_password[0],
              color:'danger',
              position:'top-right'
            })
            this.popupChangePassword = true;
          } else {
             this.$vs.notify({
              title:'Fail',
              text: err.repeat_password[0],
              color:'danger',
              position:'top-right'
            })
            this.popupChangePassword = true;
          }
        })
      } else {
        if(!this.old_password) {
          this.$vs.notify({
            title:'Fail',
            text: 'Current Password is required',
            color:'danger',
            position:'top-right'
          })
        } else if(!this.new_password) {
          this.$vs.notify({
            title:'Fail',
            text: 'New Password is required',
            color:'danger',
            position:'top-right'
          })
        } else if(!this.confirm_password) {
          this.$vs.notify({
            title:'Fail',
            text: 'Confirm Password is required',
            color:'danger',
            position:'top-right'
          })
        } else if(this.confirm_password != this.new_password) {
          this.$vs.notify({
            title:'Fail',
            text: 'Confirm Password must be equal to New Password',
            color:'danger',
            position:'top-right'
          })
        }
        this.resetData = false;
        this.popupChangePassword = true;
      }
    },
    selectItem(type) {
      this.$emit("SelectItem", type);
      this.$emit("OutAfterLogin", type);
    }
  },
  computed: {
    config() {
      return this.$store.getters["auth/config"];
    },
    userInfo() {
      return this.$store.state.auth.userInfo;
    },
  },
  // beforeDestroy() { this.$validator.pause() }
};
</script>

